import { render, staticRenderFns } from "./DeleteBagModal.vue?vue&type=template&id=b2b7578e"
import script from "./DeleteBagModal.vue?vue&type=script&lang=js"
export * from "./DeleteBagModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports